const React = require('react');
const BaseMessages = require('./BaseMessages');
const {withRouter} = require("react-router-dom");

class PushMessagesPage extends React.Component {
    render() {
        return (
            <BaseMessages messagesType={'push'}/>
        )
    }
}

module.exports = withRouter(PushMessagesPage);
